import { BodyTextRegularB } from '@/shared/ui/typography2';
import styled from 'styled-components';
import { Button } from '@radix-ui/themes';
import { Image } from '@/shared/ui/image';
import { useBrandTheme } from '@/shared/hooks';

export const BettingPartners = () => {
  const icons: string[] = ['ufc', 'fifa', 'wta', 'itf', 'fi', 'icc', 'nhl'];
  const { isMillion } = useBrandTheme();
  if (isMillion) {
    return null;
  }
  return (
    <BlockWrapper>
      <TitleContainer>
        <BodyTextRegularB color="#AFAFAF">&nbsp;</BodyTextRegularB>
        <Line />
      </TitleContainer>
      <Content>
        {icons.map((icon, index) => (
          <PayButton key={index}>
            <Image
              src={`/images/icons/footer/bp-${icon}.svg`}
              alt={icon}
              width={80}
              height={55}
            />
          </PayButton>
        ))}
      </Content>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;
const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;
const Line = styled.div`
  display: flex;
  flex: 1 0 0;
  height: 1px;
  background-color: #565656;
`;
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  overflow-y: hidden;
`;
const PayButton = styled(Button)`
  width: 80px;
  height: 55px;
`;
